<script setup lang="ts">
  import { computed } from 'vue';
  import { formActionsClass } from './FormActions.css';
  import type { FormActionsProps } from './FormActions.types';

  const props = defineProps<FormActionsProps>();

  const resolvedTestId = computed(() => props.testId ?? 'ds-form-actions');
</script>

<template>
  <div :class="formActionsClass" :data-testid="resolvedTestId">
    <slot />
  </div>
</template>
